export const CATEGORY_LABELS = {
  premium_sedan: "Premium Sedan",
  luxury_suv: "Luxury SUV",
  sport: "Sport",
  business: "Business",
  economy: "Economy",
  truck: "Truck",
  rideshare: "Rideshare-Ready",
  electric: "Electric",
};

export const CATEGORY_ORDER = [
  "premium_sedan",
  "luxury_suv",
  "sport",
  "electric",
  "business",
  "economy",
  "truck",
  "rideshare",
];

// Terminology rule: never use "RTL" abbreviation in user-facing UI. Always spell out
// "Rental Term Leasing" — see design guidelines and Drive Alfa Club page.
export const PLAN_LABELS = {
  daily: "Daily",
  weekly: "Weekly",
  monthly: "Monthly",
  rtl_3: "Rental Term Leasing — 3 months",
  rtl_6: "Rental Term Leasing — 6 months",
  rtl_12: "Rental Term Leasing — 12 months",
};

export const STATUS_LABELS = {
  pending: "Pending review",
  confirmed: "Confirmed",
  rejected: "Rejected",
  completed: "Completed",
  cancelled: "Cancelled",
};

export function currency(v) {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return "$0";
  return new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
    maximumFractionDigits: 0,
  }).format(Number(v));
}

export function currencyFine(v) {
  if (v === null || v === undefined || Number.isNaN(Number(v))) return "$0.00";
  return new Intl.NumberFormat("en-CA", {
    style: "currency",
    currency: "CAD",
    maximumFractionDigits: 2,
  }).format(Number(v));
}

export function daysBetween(startISO, endISO) {
  try {
    const s = new Date(startISO);
    const e = new Date(endISO);
    const d = Math.round((e - s) / (1000 * 60 * 60 * 24));
    return Math.max(1, d);
  } catch {
    return 1;
  }
}

export function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("en-CA", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  } catch {
    return iso || "";
  }
}
